import axios from 'axios'; // Make sure this line is present

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`; // Replace with your actual API base URL

const getAuthKey = () => {
    return `${process.env.REACT_APP_API_SECURITY_KEY}`;
  };

// Fetch all countries from the API
export const fetchCountries = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/admin/common/getcountries`,
        {
          headers: {
            'auth_key': `${getAuthKey()}`,
          }
        }
      );
      return response.data; // Return the list of countries
    } catch (error) {
      console.error('Error fetching countries:', error);
      alert('Error fetching countries:', error);
      throw error;
    }
  };
  
  // Fetch states based on selected country ID
  export const fetchStatesByCountry = async (countryId) => {
    try {
      //const response = await axios.get(`${API_BASE_URL}/states/${countryId}`);
      const response = await axios.get(`${API_BASE_URL}/admin/common/getstates/${countryId}`,
        {
          headers: {
            'auth_key': `${getAuthKey()}`,
          }
        }
      );
      return response.data; // Return the list of states
    } catch (error) {
      console.error('Error fetching states:', error);
      alert('Error fetching countries:', error);
      throw error;
    }
  };
  